import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconComponent implements OnInit {
  readonly anchor = input.required<string>();
  readonly title = input<string>('icon');
  readonly viewbox = input<string>('');

  constructor() {}

  ngOnInit(): void {
    // warn user when icon is not properly set
    if (!this.anchor()) {
      console.warn('icon anchor is required');
    }
  }
}
